export default function roundUp() {
    return function (value) {
        return Math.ceil(value);
    };
};